import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary';
import { toast } from 'react-hot-toast';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/query/queryClient';
import './index.css';

// Global error handlers to catch unhandled errors and async promise rejections on the frontend
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    console.error('[GLOBAL FRONTEND ERROR]', event.error || event.message);
    const msg = event.error?.message || event.message || 'Erro inesperado no sistema';
    // Ignore ResizeObserver loop errors and iframe communication limits
    if (msg.includes('ResizeObserver') || msg.includes('Script error') || msg.includes('postMessage') || msg.includes('Maximum call stack size exceeded')) return;
    toast.error(`Erro no Frontend: ${msg}`, { id: 'global-frontend-error' });
  });

  window.addEventListener('unhandledrejection', (event) => {
    console.error('[UNHANDLED PROMISE REJECTION]', event.reason);
    const reasonMsg = typeof event.reason === 'string' 
      ? event.reason 
      : event.reason?.message || 'Promessa rejeitada sem tratamento';
    
    // Ignore aborted fetch requests and postMessage stack size issues
    if (
      event.reason?.name === 'AbortError' || 
      reasonMsg.includes('canceled') || 
      reasonMsg.includes('postMessage') || 
      reasonMsg.includes('Maximum call stack size exceeded')
    ) return;

    toast.error(`Erro assíncrono: ${reasonMsg}`, { id: 'unhandled-promise-rejection' });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);

